import TotalProfit from './totalProfit.png';

const ProfitExamples3 = () => {
  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <p style={{ fontSize: 24, fontWeight: 'bold' }}>
        Total Realized profits Distribution
      </p>
      <div
        style={{
          display: 'flex',
          height: '100%',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img src={TotalProfit} style={{ height: '50vh', width: '70vw' }} />
      </div>
    </div>
  );
};

export default ProfitExamples3;
